import { uniqueId } from 'lodash';

class AlertModel {
  id;
  origin;
  type;
  ts;
  message;
  showAlert;
  status;

  static ALERT_TYPE = {
    GENERAL: 'general',
  }

  /**
   * @constructor
   * @param options
   * @param options.id {String} id of the alert
   * @param options.origin {String} the widget and the metric that triggered this alert
   * @param options.type {String} type of the alerts - error/warning/info/....
   * @param options.ts {String} timestamp
   * @param options.message {String} alert's message
   * @param options.showAlert {Boolean} is alert currently active and should be shown in UI
   * @param options.status {String} alert status - start/end/disabled/other?
   */
  constructor(options) {
    this.id = options.id || uniqueId();
    this.origin = options.origin;
    this.type = options.type || AlertModel.ALERT_TYPE.GENERAL;
    this.ts = options.ts || new Date().getTime();
    this.message = options.message;
    this.showAlert = options.showAlert;
    this.status = options.status;
  }
}

export default AlertModel;
